import { SupernovaError } from "../errors/SDKSupernovaError";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Versions Area
export class AreaVersions {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /** Fetches active design system version - the one to which all changes are being written currently. There is always one active version available for any provided design system. */
    async getActiveVersion(designSystemId) {
        const versions = await this.dataCore.versions(designSystemId);
        // Retrieve version that is currently active and available for write
        const activeVersion = versions.find((version) => !version.isReadonly);
        if (activeVersion) {
            return activeVersion;
        }
        throw SupernovaError.fromMessage(`Unable to retrieve active version for design system id ${designSystemId} - no version is currently active in selected design system`);
    }
    /** Creates new version and retrieves the newly created version object.
     * @param designSystemId - ID of the design system
     * @param model - new version model
     * @returns Newly created version object
     */
    async createVersion(designSystemId, model) {
        return this.dataCore.createVersion(designSystemId, model);
    }
    /** Edits version
     * @param designSystemId - ID of the design system
     * @param versionId - ID of version
     * @param model - new version model
     * @returns nothing
     */
    async editVersion(designSystemId, versionId, model) {
        await this.dataCore.editVersion(designSystemId, versionId, model);
    }
    /** Deletes version
     * @param designSystemId - ID of the design system
     * @param versionId - ID of version
     * @returns nothing
     */
    async deleteVersion(designSystemId, versionId) {
        await this.dataCore.deleteVersion(designSystemId, versionId);
    }
    /** Fetches all design system versions of provided design system */
    async getVersions(designSystemId) {
        return this.dataCore.versions(designSystemId);
    }
    /** Fetches design system version by id */
    async getVersion(from) {
        return this.dataCore.version(from.designSystemId, from.versionId);
    }
    /** Fetches version creation job */
    async getVersionCreationJob(designSystemId, jobId) {
        return this.dataCore.versionCreationJob(designSystemId, jobId);
    }
    /** Fetches all version creation jobs */
    async getVersionCreationJobs(designSystemId) {
        return this.dataCore.versionCreationJobs(designSystemId);
    }
    async getTokenStudioData(from) {
        return this.dataCore.getTokenStudioData(from.designSystemId, from.versionId);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Create/Update
    async writeTokenStudioData(from, data) {
        return this.dataCore.writeTokenStudioData(from.designSystemId, from.versionId, data);
    }
}
